var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-widget-radio"},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,staticClass:"chat-widget-radio__option",class:{
      'chat-widget-radio__option--selected': _vm.selectedValue === option.value,
      'chat-widget-radio__option--disabled': _vm.disabled,
    },on:{"click":function($event){!_vm.disabled && _vm.selectOption(option.value)}}},[_c('input',{staticClass:"mr-2",attrs:{"type":"radio","disabled":_vm.disabled},domProps:{"checked":_vm.selectedValue === option.value}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }